import React from 'react'
import { Modal, Button } from 'antd'
import Form from './Form'

type Props = {
  submitting: boolean,
  componentWillMount: () => void,
  onClickSubmit: () => void,
  onClickCancel: () => void,
  forcingReset?: boolean,
}

export default class extends React.PureComponent<Props> {

  componentWillMount = () => this.props.componentWillMount(this.props)

  render() {

    const {
      submitting,
      onClickSubmit,
      onClickCancel,
        forcingReset,
    } = this.props

    const footer = []

    const buttons = [
      <Button key='save' type='primary' loading={submitting} onClick={onClickSubmit}>
        Save
      </Button>,
    ]

    if (!forcingReset) {
      buttons.unshift(
        <Button key='cancel' disabled={submitting} onClick={onClickCancel}>
          Cancel
        </Button>
      )
    }

    footer.push(buttons)

    return (

      <Modal
        title='Reset Password'
        footer={footer}
        onCancel={forcingReset ? null : onClickCancel}
        closable={!forcingReset}
        maskClosable={!forcingReset}
        visible
      >

        <Form
          submitting={submitting}
          forcingReset={forcingReset}
        />

      </Modal>

    )

  }

}
